import React, { useEffect, useRef, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import './CopyableCode.scss';

interface Props {
  value: string;
  children?: React.ReactNode;
  title?: string;
}

type CopyState = 'idle' | 'copied' | 'failed';

const FEEDBACK_DURATION_MS = 1500;

export const CopyableCode = ({ value, children, title }: Props) => {
  const [state, setState] = useState<CopyState>('idle');
  const timeoutRef = useRef<number>();

  useEffect(() => () => window.clearTimeout(timeoutRef.current), []);

  const handleClick = async () => {
    let next: CopyState = 'copied';
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      next = 'failed';
    }
    setState(next);
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(
      () => setState('idle'),
      FEEDBACK_DURATION_MS,
    );
  };

  const tooltip = {
    idle: title ?? 'Click to copy',
    copied: 'Copied!',
    failed: 'Copy failed',
  }[state];

  return (
    <Tooltip title={tooltip} arrow describeChild>
      <button
        type="button"
        className="lending-support-code lending-support-code-copyable"
        onClick={handleClick}
      >
        {children ?? value}
      </button>
    </Tooltip>
  );
};
